export const CONFIRMED_CREATE_SCRIPT_ACTION = "CONFIRMED_CREATE_SCRIP_ACTION";
export const CONFIRMED_DELETE_SCRIPT_ACTION = "CONFIRMED_DELETE_SCRIPT_ACTION";
export const CONFIRMED_EDIT_SCRIPT_ACTION = "CONFIRMED_EDIT_SCRIPT_ACTION";
export const CONFIRMED_GET_SCRIPT = "CONFIRMED_GET_SCRIPT";
